<template>
<div class="main-wrap" v-loading="parentRoot.loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8) "  element-loading-text="Getting login information">
  <div class="sub_top_menu">
    <serve />
  </div>
  <div class="header-top">
    <div class="w1180">
        <div class="tech-left">
          <slot name="logoshow"></slot>
          <ul class="naver-bar01 navBar_header" v-if="hash != '/newregister'">
            <li v-for="(item,index) in topNavList" :key="index + '10'" 
            :class="{'active':item.url && hash.search(item.url)!=-1 }">
              <template v-if="item.url != '/games' || (item.url == '/games' && gameMenuIsShow == '1')">
              <a href="javascript:void(0)" @click="routerJump(item)" >
                <!-- <span class="logoImg" :style="{backgroundImage:'url(' + item.logoImg + ')'}"></span> -->
                <span>{{$t(item.name)}}</span>
                <span>{{ item.type }}</span>
              </a>
              </template>
            </li>
          </ul>
        </div>
        <slot name="btnlogo" v-if="hash != '/newregister'"></slot>
        </div>

    </div>
    <!-- <div class="header-bottom" v-if="hash != '/newregister'">
      <ul class="naver-bar02 navBar_header">
          <li v-for="(item,index) in topNavarr" :key="index" 
          :class="{'active':item.url && hash.search(item.url)!=-1 }"
          >
            <a href="javascript:void(0)" @click="routerJump(item)">
            <span>{{$t(item.name)}}</span>
            </a>
          </li>
      </ul>
    </div> -->
</div>
</template>

<script>
import serve from './serve.vue'
import { topNavList,topNavarr } from '../utils/Data.js'
import { mapState,mapMutations } from "vuex";
export default {
  inject:['parentRoot'],
  components:{ serve },
  props:{
    propsDownFun:{
        type:Function,
        default:function(){}
    }
  },
  data(){
      return{
        topNavList,
        topNavarr
      }
  },
  computed:{
    ...mapState({
        customer_service_system_link: (state) =>state.FrontConfigList.customer_service_system_link,
        agent_url: (state) =>state.FrontConfigList.agent_url,    //代理链接
        UUID: (state) => state.UUID,
        isLogin: (state) => state.isLogin,
        gameMenuIsShow: (state) => state.linkList.gameMenuIsShow,
    }),
    hash(){
      return this.$route.fullPath
    },
  },
  methods:{
    ...mapMutations(["setshowloginfloat2"]),
    routerJump({ url,isGame }){
      if(isGame){
        // if(isGame == 'agency' && this.agent_url){
          // return window.open(this.agent_url)
        // }else 
        if(isGame == 'service' && this.customer_service_system_link){
           return window.open(this.customer_service_system_link)
        }else if(isGame =='APPDownload'){
          return  this.$emit('handleClose')
        }
      }else{
        if(url == '/team' && !this.isLogin){
          this.setshowloginfloat2(true)
        }else{
          this.$router.push(url)
        }
      }
    },
  },
}

</script>

<style lang="scss" scoped>
 .header-bottom{
  display:flex;
  justify-content: space-between;
  align-items: center;
  padding:0 31px;
  height: 38px;
  background-image:url('./img/header_bottom_bg.jpg');
  background-size: 100% 38px;
  background-position: center top;
  line-height: 38px;
}
.navBar_header{
  display: flex;
  align-items: center;
  padding-top: 10px;
  li{
    a{ 
      font-family: Roboto-Bold;
      font-size: 14px;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ffffff;
      font-weight: 550;
      padding:6px 13px;
    };
  }
  &.naver-bar01{
    padding-left:25px;
    li{ margin-left:10px; }
    li a{ 
      font-size: 16px;
      .logoImg{
        display:inline-block;
        width:21px;
        height:21px;
        background-size: 100%;
        background-repeat: no-repeat;
        background-position-y:0%;
        vertical-align: middle;
        margin-top:-2px;
      }
    }
    li{
      &:hover,&.active{ 
        a{
          background:#fff;
          border-radius: 20px;
          font-family: Roboto-Black;
          color: #13aef8;
          .logoImg{ background-position-y:100%; }
        }
      }
    }
  }
}
.main-wrap {
  min-width:1240px;
  width: 100%;
  position: fixed;
  z-index:999;

  .header-top {
    height:90px;
    line-height: 64px;
    background-image:url('./img/header_top_bg.jpg');
    background-size: 100% 90px;
    background-position: center top;
      .w1180{
        width: 1180px; margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

    .tech-left{
      display:flex;   
      align-items: center;                 
      height:100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/build901/components/Header/navBar.vue